export default __webpack_public_path__ + "static/media/logo-salute-white.d71eefe2.png";